/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_login_api_v1_auth_login_post } from '../models/Body_login_api_v1_auth_login_post';
import type { GoogleAuthCallback } from '../models/GoogleAuthCallback';
import type { LogoutRequest } from '../models/LogoutRequest';
import type { RefreshTokenRequest } from '../models/RefreshTokenRequest';
import type { Token } from '../models/Token';
import type { TwoFASetupResponse } from '../models/TwoFASetupResponse';
import type { TwoFAVerifyRequest } from '../models/TwoFAVerifyRequest';
import type { UserCreate } from '../models/UserCreate';
import type { UserRegisterResponse } from '../models/UserRegisterResponse';
import type { UserSessionResponse } from '../models/UserSessionResponse';
import type { VerificationResendRequest } from '../models/VerificationResendRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * Register
     * @param requestBody
     * @returns UserRegisterResponse Successful Response
     * @throws ApiError
     */
    public static registerApiV1AuthRegisterPost(
        requestBody: UserCreate,
    ): CancelablePromise<UserRegisterResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify Email
     * Verify user email with token
     * @param token
     * @returns any Successful Response
     * @throws ApiError
     */
    public static verifyEmailApiV1AuthVerifyEmailTokenGet(
        token: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/auth/verify-email/{token}',
            path: {
                'token': token,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Resend Verification
     * Resend verification email
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static resendVerificationApiV1AuthResendVerificationPost(
        requestBody: VerificationResendRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/resend-verification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Login
     * @param formData
     * @returns Token Successful Response
     * @throws ApiError
     */
    public static loginApiV1AuthLoginPost(
        formData: Body_login_api_v1_auth_login_post,
    ): CancelablePromise<Token> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/login',
            formData: formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Logout
     * Logout user by blacklisting their tokens and clearing cookies.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static logoutApiV1AuthLogoutPost(
        requestBody?: (LogoutRequest | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/logout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Refresh Access Token
     * Refresh access token using refresh token
     * @param requestBody
     * @returns Token Successful Response
     * @throws ApiError
     */
    public static refreshAccessTokenApiV1AuthRefreshPost(
        requestBody?: (RefreshTokenRequest | null),
    ): CancelablePromise<Token> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/refresh',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Sessions
     * Get active sessions
     * @returns UserSessionResponse Successful Response
     * @throws ApiError
     */
    public static getSessionsApiV1AuthSessionsGet(): CancelablePromise<Array<UserSessionResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/auth/sessions',
        });
    }
    /**
     * Revoke Session
     * Revoke a session
     * @param sessionId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static revokeSessionApiV1AuthSessionsSessionIdDelete(
        sessionId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/auth/sessions/{session_id}',
            path: {
                'session_id': sessionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Setup 2Fa
     * Initialize 2FA setup
     * @returns TwoFASetupResponse Successful Response
     * @throws ApiError
     */
    public static setup2FaApiV1Auth2FaSetupPost(): CancelablePromise<TwoFASetupResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/2fa/setup',
        });
    }
    /**
     * Verify 2Fa
     * Verify 2FA setup with code
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static verify2FaApiV1Auth2FaVerifyPost(
        requestBody: TwoFAVerifyRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/2fa/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Disable 2Fa
     * Disable 2FA
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static disable2FaApiV1Auth2FaDisablePost(
        requestBody: TwoFAVerifyRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/2fa/disable',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Google Initiate
     * Returns Google OAuth URL
     * @returns any Successful Response
     * @throws ApiError
     */
    public static googleInitiateApiV1AuthGoogleInitiateGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/auth/google/initiate',
        });
    }
    /**
     * Google Callback
     * Handle Google OAuth callback
     * @param requestBody
     * @returns UserRegisterResponse Successful Response
     * @throws ApiError
     */
    public static googleCallbackApiV1AuthGoogleCallbackPost(
        requestBody: GoogleAuthCallback,
    ): CancelablePromise<UserRegisterResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/google/callback',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
